import React from 'react';
import Typography from '@mui/material/Typography';

interface TextProps {
  addStyle?: any;
  // Add any other props you'd like the Typography component to accept
  [x: string]: any;  // for other props that may be passed down
}

const Text: React.FC<TextProps> = ({ addStyle, ...props }) => {
  return (
    <Typography className={addStyle} {...props} />
  );
}

export default Text;
